<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { Permission } from "../../../../../types/auth";
import { FilterField, TableField } from "../../../../../components/table/table";
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";
import VariantUpdateForm from "./VariantUpdateForm.vue";
import Buttons from "../../../../../components/ui/form/Buttons.vue";
import UpdateVariantPrices from "./UpdateVariantPrices.vue";

const props = defineProps<{
  data?: any | [];
  unit_of_measures?: any | [];
  permissions?: Permission[];
  item?: any | null;
}>();

const endPoint = "/clients/inventory/item-management/items/";
const title = "Item Variants";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);
const showVariantPricesForm = ref(false);

const rows = ref<any[]>(props.data);

const fields: TableField[] = [];

const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  console.log("handleData", data);
  selectedData.value = data;
};

const prepareGrid = () => {
  if (props.data && props.data.length > 0) {
    const columnNames = Object.keys(props.data[0]).filter(key => key !== "id");
    fields.push({
          name: 'photo',
          caption: 'Photo',
          sortable: false,
          fieldType: "image",
        });
    columnNames.forEach((col) => {
      if (col.endsWith('_id') || col == "uid") {
        return;
      }
      if (col != "code" && col != "name" && col != "photo" && col != "variant") {
        fields.push({
          name: col,
          caption: col,
          sortable: false,
          fieldType: "number",
        });
      } else if (col != "photo") {
        fields.push({
          name: col,
          caption: col,
          sortable: false,
          fieldType: "text",
        });
      }
    });
    console.log("rows", props.data);
    rows.value = props.data;
    //rows.value = props.data;    
  }
}
onMounted(() => {
  prepareGrid();
});

const handleDataSaved = (data: any) => {
  rows.value = data.item_variants;
  refreshData.value = !refreshData.value;
  showForm.value = false;
};

watch(
  () => props.data,
  () => {
    prepareGrid();
  },
  { immediate: true }
);
</script>

<template>
  <ListTemplate
    :endPoint="endPoint"
    :title="title"
    :fields="fields"
    :actions="[]"
    :filterFields="filterFields"
    :tabList="[]"
    :refreshData="refreshData"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @data="handleData"
    :data="rows"
    :remote="false"
    :showHeader="false"
    :showQuickTour="false"
    :showQuickView="false"
    :showPagination="false"
    :allowDisable="false"
    :allow-edit="true"
    :ignore-max-height="true"
  >
    <template #header-actions>
      <Buttons caption="Update Prices" icon="WalletCards" @click="showVariantPricesForm = true" />
    </template>
  </ListTemplate>
  <VariantUpdateForm
    v-if="showForm"
    :data="selectedData"
    :permissions="permissions"
    :endPoint="endPoint"
    title="Item Variants"
    @save="handleDataSaved"
    :mode="formMode"
    :item="props.item"
    @close="showForm = false"/>
    <UpdateVariantPrices
      v-if="showVariantPricesForm"
      :item="props.item"
      :permissions="props.permissions"
      :endPoint="endPoint"
      title="Update Variant Prices"
      @save="handleDataSaved"
      mode="create"
      @close="showVariantPricesForm = false"/>
</template>
